import React from 'react';
import { FlatList, StyleSheet, Text, TouchableOpacity } from 'react-native';

import { colors, fonts, scale } from '../../Styles';
import { DateConverters } from '../../util/DateConverters';
import { TranscriptHistoryProps } from '../containers/TranscriptHistoryContainer';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSFloatingIndicator } from '../MNOHSFloatingIndicator';

export const TranscriptHistoryScreen: React.FC<TranscriptHistoryProps> = ({
  isGettingTranscripts,
  transcriptRequests,
}) => {
  const converter = DateConverters['YYYY-MM-DD'];
  return (
    <MNOHSDashboardWrapper headerTitle={'Transcript Request History'}>
      {isGettingTranscripts ? (
        <MNOHSFloatingIndicator block={true} padded={true} />
      ) : (
        !Boolean(transcriptRequests.length) && <Text style={styles.emptyText}>No transcript history found</Text>
      )}

      <FlatList
        style={styles.flatList}
        data={transcriptRequests}
        keyExtractor={(item, index) => item.id}
        renderItem={({ item }) => {
          return (
            <TouchableOpacity disabled={true} style={styles.itemContainer}>
              <Text style={styles.itemText}>{item.requestSubject}</Text>
              <Text style={styles.itemText}>
                <Text style={styles.badgeText}>{item.typeOfTranscript}</Text>
                {converter.toString(new Date(item.dateRequested))}
              </Text>
            </TouchableOpacity>
          );
        }}
      />
    </MNOHSDashboardWrapper>
  );
};

const styles = StyleSheet.create({
  flatList: {
    marginTop: scale(4),
    marginBottom: scale(52),
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingHorizontal: scale(16),
    paddingVertical: scale(12),
    marginVertical: scale(4),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  itemText: {
    ...fonts.paragraph,
  },
  badgeText: {
    ...fonts.linkedText,
    fontSize: scale(12),
    paddingHorizontal: scale(4),
    borderRadius: scale(4),
    backgroundColor: colors.black,
    color: colors.white,
    marginRight: scale(6),
  },
  emptyText: {
    ...fonts.paragraph,
    textAlign: 'center',
    marginVertical: scale(20),
  },
});
